<template>
  <div >
      <div class="pot" v-for="pot, idx in pots" :key="idx">
          {{ getPot(pot) }}
      </div>
  </div>
</template>

<script>
export default {
  props: {
    pots: Array,
    state: Object
  },
  methods: {
    getPot(pot) {
      let d = this.getDivider();
      return (pot.chips / d).toFixed(2);
    },
    getDivider() {
      if (!this.state || !this.state.settings) {
        return 1;
      }
      let s = this.state.settings;
      if (s.withDecimal) {
        return 100;
      }
      return 1;
    },
  }
}
</script>

<style scoped>
.pot {
    background-color: darkkhaki;
    border: 2px solid black;
    border-radius: 20px;
    color: black;
    font-weight: bolder;
    padding: 8px;
    display: flex;
    position: absolute;
    top: 245px;
    left: 170px;
}
</style>
